import React from "react";
import { Block } from "@/lib/blocks";
import landing from "@/content/landing.json";

/**
 * Renders the landing page from the content bundled with the build.
 *
 * This used to call useStoryblok() and fetch from the Storyblok CDN on every
 * page load. That dependency is gone: the content lives in
 * src/content/landing.json, which was already the source of truth (the CMS copy
 * was last touched in February and was byte-identical to this file). Rendering
 * it locally also removes the empty-black-screen state the old code showed
 * whenever the fetch failed — with the subscription lapsing, that state would
 * have become permanent.
 *
 * To change copy: edit src/content/landing.json and deploy.
 */
export const LandingRoute: React.FC = () => (
  <Block blok={(landing as { content: Record<string, unknown> }).content} />
);

// Old name kept so App.tsx and any bookmarks/imports keep working.
export const StoryblokPage = LandingRoute;

export default LandingRoute;
